<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="settings.currency.title">
    </sm-page-header>
    <div class="content">
        <div class="flex justify-end mb-4">
            <p-button [label]="'settings.currency.history.check' | translate" (click)="router.navigate(['/settings/currency/history'])" severity="info"/>
        </div>
        <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data"
            [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
    </div>

    <sm-drawer #drawer [drawer]="currencyDrawer"></sm-drawer>
    <sm-dialog #dialog [dialog]="currencyDialog"></sm-dialog>
</div>